import React, {useEffect, useState} from 'react';
import FilterCheckBox from '../FilterCheckBox';
import FilterPopover from "../FilterPopover";
import {Button} from "ui";
import {useLecture} from "hooks/Lectures/useLecture";

interface LectorsDepartmentsFilterInterface {
    tagBuilder: () => void;
    session?: unknown;
    setFilterValues: React.Dispatch<React.SetStateAction<Record<string, unknown>>>;
    filterValues: Record<string, unknown>;
    form: { setFieldsValue: (values: unknown) => void; getFieldsValue: () => unknown };
    filterKey: string;
    setFilterKey: React.Dispatch<React.SetStateAction<string>>;
}

const LectorsDepartmentsFilter: React.FC<LectorsDepartmentsFilterInterface> = ({
                                                                                   filterKey,
                                                                                   setFilterKey,
                                                                                   form,
                                                                                   tagBuilder,
                                                                                   setFilterValues,
                                                                                   filterValues
                                                                               }) => {
    const {searchLectorsDepartments, lectureLoading: isLoading} = useLecture()
    const [data, setData] = useState<Record<string, unknown>>({});
    const [initialValues, setInitialValues] = useState<unknown>(undefined)

    const key = 'lectorsDepartments'

    useEffect(() => {
        onSearch()
    }, [])

    const onSearch = async (value: string = '') => {
        const response = await searchLectorsDepartments(value)
        const safeResponse: Record<string, unknown> = (response && typeof response === 'object') ? response : {};

        setData(safeResponse);
        setFilterValues(
            {
                ...filterValues,
                lectorsDepartments: {
                    ...(((filterValues as Record<string, unknown>).lectorsDepartments as Record<string, unknown>) ?? {}),
                    ...safeResponse
                }
            }
        )
    };

    const content = (
        <>
            <FilterCheckBox data={data} name={'lectorsDepartments'} onSearch={onSearch}/>
            <div className={'flex justify-between p-1'}>
                <Button type={'link'} onClick={() => handleClose()} message='general.cancel' />
                <Button type={'primary'} onClick={() => {setFilterKey(''); handleOpen(false);}} message='general.select' />
            </div>
        </>
    );

    const handleClose = () => {
        form.setFieldsValue(initialValues);
        setFilterKey('');
    }


    const handleOpen = (open: boolean) => {
        if (open) {
            setInitialValues(form.getFieldsValue())
            setFilterValues(
                {
                    ...filterValues,
                    lectorsDepartments: {
                        ...(((filterValues as Record<string, unknown>).lectorsDepartments as Record<string, unknown>) ?? {}),
                        ...data
                    }
                }
            )
        } else {
            tagBuilder()
        }
    }

    return (
        <FilterPopover
            popoverKey={key}
            filterKey={filterKey}
            setOpen={setFilterKey}
            handleOpen={handleOpen}
            content={content}
            loading={isLoading}
            title={'general.search_by_lectors_departments'}
            buttonTitle={'general.lector_departments'}
        />
    );
};

export default LectorsDepartmentsFilter;